<ng-lottie class="spinner" [options]="options | async" [height]="height + 'px'"></ng-lottie>
